/* import __COLOCATED_TEMPLATE__ from './ilios-calendar-day.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { DateTime } from 'luxon';
import { deprecate } from '@ember/debug';
let IliosCalendarDayComponent = (_class = class IliosCalendarDayComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "localeDays", _descriptor, this);
  }
  get date() {
    if (typeof this.args.date === 'string') {
      deprecate(`String passed to IliosCalendarDay @date instead of Date`, false, {
        id: 'common.dates-no-strings',
        for: 'ilios-common',
        until: '72',
        since: '71'
      });
      return DateTime.fromISO(this.args.date).toJSDate();
    }
    return this.args.date;
  }
  get today() {
    return DateTime.fromJSDate(this.date).startOf('day');
  }
  get events() {
    return this.args.calendarEvents.filter(event => DateTime.fromISO(event.startDate).hasSame(this.today, 'day') || DateTime.fromISO(event.endDate).hasSame(this.today, 'day'));
  }
  get ilmPreWorkEvents() {
    const preWork = this.args.calendarEvents.reduce((arr, ev) => {
      if (!ev.isBlanked && ev.isPublished && !ev.isScheduled) {
        arr = [...arr, ...ev.prerequisites];
      }
      return arr;
    }, []);
    return preWork.filter(ev => ev.ilmSession).filter(ev => {
      return !ev.isBlanked && ev.isPublished && !ev.isScheduled;
    });
  }
  get nonIlmPreWorkEvents() {
    return this.events.filter(ev => {
      return ev.postrequisites.length === 0 || !ev.ilmSession;
    });
  }
  get singleDayEvents() {
    return this.nonIlmPreWorkEvents.filter(event => DateTime.fromISO(event.startDate).hasSame(DateTime.fromISO(event.endDate), 'day'));
  }
  get multiDayEvents() {
    return this.nonIlmPreWorkEvents.filter(event => !DateTime.fromISO(event.startDate).hasSame(DateTime.fromISO(event.endDate), 'day'));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "localeDays", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { IliosCalendarDayComponent as default };